//
// Main Nav functions
//

const DESKTOPNAV_TRIGGER_CLASS = '.js-dt-menu__trigger';
const DESKTOPNAV_MENU_CLASS = '.js-mega-nav';
const DESKTOPNAV_OVERLAY_ID = '#js-dt-menu-overlay';

export default class NavMenuDesktop {
  constructor() {

    // Desktop nav elements
    this.megaNavTriggers = document.querySelectorAll(DESKTOPNAV_TRIGGER_CLASS);
    this.megaNavElems = document.querySelectorAll(DESKTOPNAV_MENU_CLASS);
    this.megaNavOverlay = document.querySelector(DESKTOPNAV_OVERLAY_ID);
    if (!this.megaNavTriggers) return;

    this.init();
  }

  init() {
    this.addEventHandling();
  }

  /**
   * @public
   */
  toggleMegaNav(event) {

    // Get target nav
    let currentNavButton = event.currentTarget;
    let targetNavMenu = currentNavButton.getAttribute('aria-controls');

    this.handleMegaNavTriggers(currentNavButton);
    this.handleAllMegaNavs(targetNavMenu);
  }

  /**
   * @public
   */
  handleMegaNavTriggers(currentNavButton) {
    // Remove active class from all buttons, and add to clicked one
    this.megaNavTriggers.forEach(megaNavTrigger => {
      if (megaNavTrigger != currentNavButton) {
        megaNavTrigger.classList.remove('dt-menu__top-link--active');
        megaNavTrigger.setAttribute('aria-expanded', 'false');
      } else {
        megaNavTrigger.classList.toggle('dt-menu__top-link--active');
        megaNavTrigger.getAttribute('aria-expanded') == 'false' ? megaNavTrigger.setAttribute('aria-expanded', "true") : megaNavTrigger.setAttribute('aria-expanded', "false");

        if (megaNavTrigger.classList.contains('dt-menu__top-link--active')) {
            this.handleMegaNavOverlay('show');
        } else {
            this.handleMegaNavOverlay('hide');
        }
      }
    });
  }

  /**
   * @public
   */
  handleAllMegaNavs(targetNavMenu) {
    // Hide all Nav Elemns and show clicked one
    this.megaNavElems.forEach(megaNavElem => {
      // Get MegaNav ID
      let currentMegaNavElem = megaNavElem.id;

      // If current nav matches target button, then show
      if (currentMegaNavElem === targetNavMenu) {
        megaNavElem.classList.toggle('mega-nav--active');
      } else {
        megaNavElem.classList.remove('mega-nav--active');
      }
    });
  }

  /**
   * @public
   */
  handleMegaNavOverlay(action) {

    const mNOlEl = this.megaNavOverlay;

    if (action == 'show') {
      mNOlEl.classList.add('dt-menu-overlay--active');
    } else {
      mNOlEl.classList.remove('dt-menu-overlay--active');
    }

    mNOlEl.getAttribute('aria-hidden') == 'false' ? mNOlEl.setAttribute('aria-hidden', "true") : mNOlEl.setAttribute('aria-hidden', "false");
  }

  /**
   * @public
   */
  addEventHandling() {
    // Mega Nav Buttons
    this.megaNavTriggers.forEach(megaNavTrigger => {
      megaNavTrigger.addEventListener('click', this.toggleMegaNav.bind(this));
    });

    // Mega Nav Keyboard Control: Use Escape key to close Mega Nav
    document.addEventListener('keyup', e => {
      if (e.key === 'Escape' && document.querySelector('.mega-nav--active')) {
        this.handleMegaNavTriggers(this);
        this.handleAllMegaNavs(this);
        this.handleMegaNavOverlay('hide');
      }
    });

    // Mega Nav Overlay: If overlay clicked, hide main nav
    this.megaNavOverlay.addEventListener('click', e => {
      this.handleMegaNavTriggers(this);
      this.handleAllMegaNavs(this);
      this.handleMegaNavOverlay('hide');
    })
  }
}